import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MeasureUnitsList } from './shared/measure-units/measure-units-list';

@Component({
  selector: 'tf-settings-page-measure-units',
  imports: [MeasureUnitsList],
  template: `<div class="settings-page">
    <div class="settings-page__content">
      <tf-settings-measure-units-list />
    </div>
  </div>`,
  styleUrl: './settings-measure-units.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasureUnitsSettings {}
